import { onBeforeMount, onMounted, onUnmounted, watchEffect, nextTick } from 'vue'
import { useUserInfoStore } from '@/store'
import { storeToRefs } from 'pinia'
import { goNoAuthPage } from '@/utils'
import { OKRNOAPP } from '@/pages/noAuth/utils/index.js'

export function checkOkrPremision() {
  const userInfoStore = useUserInfoStore()
  let { isCanPreviewOkr } = storeToRefs(userInfoStore)
  if (isCanPreviewOkr.value === false) {
    goNoAuthPage(OKRNOAPP)
    return false
  }
  return true
}

export function useCheckOkr() {
  const userInfoStore = useUserInfoStore()
  let destory = null
  onBeforeMount(() => {
    destory = watchEffect(() => {
      let { isCanPreviewOkr } = storeToRefs(userInfoStore)
      if (isCanPreviewOkr.value === false) {
        goNoAuthPage(OKRNOAPP)
      }
    })
  })
  onUnmounted(() => {
    if (destory) {
      destory()
      destory = null
    }
  })
}
